import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { QueryState } from '@/components/feedback/query-state';
import { SkeletonSheet } from '@/components/feedback/skeletons';
import { PageHeader } from '@/components/page-header';
import { StaffActions } from '@/components/staff/staff-actions';
import {
  RoleChips,
  StaffBody,
  StaffStateBadge,
} from '@/components/staff/staff-parts';
import { Alert } from '@/components/ui/alert';
import { adminQuery } from '@/lib/query';

export const Route = createFileRoute('/_app/staff/$staffId')({
  component: StaffMemberPage,
});

/** One staff member on their own page: the same parts as the sheet. */
function StaffMemberPage() {
  const { staffId } = Route.useParams();
  const list = useQuery(adminQuery('staff.list', {}));
  return (
    <QueryState
      query={list}
      label="this staff member"
      skeleton={<SkeletonSheet />}
    >
      {(rows) => {
        const member = rows.find((staff) => staff.id === staffId);
        if (!member) return <Alert>No such staff member.</Alert>;
        return (
          <div className="flex max-w-3xl flex-col gap-6">
            <PageHeader
              title={member.display_name}
              description={member.email}
              actions={<StaffStateBadge member={member} size="md" />}
            />
            <RoleChips member={member} />
            <StaffBody member={member} />
            <div className="rounded-lg border border-border bg-card p-4">
              <StaffActions member={member} />
            </div>
          </div>
        );
      }}
    </QueryState>
  );
}
